import { useState } from "react";
import { animated, useSpring } from "@react-spring/web";
import ReactPlayer from "react-player";
import Play from "./files/play-fill.svg";
import Pause from "./files/pause-fill.svg";
import Logo from "../../logo.png";

import "./Video.css";
import useMediaQuery from "../../hooks/useMediaQuery";

const Muted = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="currentColor"
    viewBox="0 0 16 16"
  >
    <path d="M6.717 3.55A.5.5 0 0 1 7 4v8a.5.5 0 0 1-.812.39L3.825 10.5H1.5A.5.5 0 0 1 1 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06zm7.137 2.096a.5.5 0 0 1 0 .708L12.207 8l1.647 1.646a.5.5 0 0 1-.708.708L11.5 8.707l-1.646 1.647a.5.5 0 0 1-.708-.708L10.793 8 9.146 6.354a.5.5 0 1 1 .708-.708L11.5 7.293l1.646-1.647a.5.5 0 0 1 .708 0z" />
  </svg>
);

const Unmuted = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="currentColor"
    viewBox="0 0 16 16"
  >
    <path d="M11.536 14.01A8.473 8.473 0 0 0 14.026 8a8.473 8.473 0 0 0-2.49-6.01l-.708.707A7.476 7.476 0 0 1 13.025 8c0 2.071-.84 3.946-2.197 5.303l.708.707z" />
    <path d="M10.121 12.596A6.48 6.48 0 0 0 12.025 8a6.48 6.48 0 0 0-1.904-4.596l-.707.707A5.483 5.483 0 0 1 11.025 8a5.483 5.483 0 0 1-1.61 3.89l.706.706z" />
    <path d="M8.707 11.182A4.486 4.486 0 0 0 10.025 8a4.486 4.486 0 0 0-1.318-3.182L8 5.525A3.489 3.489 0 0 1 9.025 8 3.49 3.49 0 0 1 8 10.475l.707.707zM6.717 3.55A.5.5 0 0 1 7 4v8a.5.5 0 0 1-.812.39L3.825 10.5H1.5A.5.5 0 0 1 1 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06z" />
  </svg>
);

const VideoSection = () => {
  const [playing, setPlaying] = useState(false);
  const [muted, setMuted] = useState(true);
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);
  // const thumbnialStyle = useSpring({
  //   opacity: isVideoLoaded ? 0 : 1,
  // });

  const md = useMediaQuery("(min-width: 768px)");

  const buttonStyle = useSpring({
    opacity: isVideoLoaded ? 1 : 0,
  });

  const onLoadedData = () => {
    setIsVideoLoaded(true);
    setPlaying(true);
  };

  return (
    <section className="section-video flex items-center">
      <ReactPlayer
        className="video-player"
        url={
          md
            ? require("./files/horizontal.mp4")
            : require("./files/vertical.mp4")
        }
        autoPlay={true}
        playing={playing}
        playsinline={true}
        controls={false}
        loop={true}
        muted={muted}
        onReady={onLoadedData}
        width="100%"
        height="100%"
        config={{
          file: {
            attributes: {
              preload: "auto",
              playsInline: true,
            },
          },
        }}
      />
      <animated.div
        role="button"
        className="z-40 flex flex-row items-center justify-center button play-button"
        style={buttonStyle}
        onClick={() => {
          setPlaying((playing) => !playing);
        }}
      >
        <div className="flex items-center relative">
          <span style={{ position: "absolute", right: 40 }}>
            {playing ? "pause" : "play"}
          </span>
          <img
            src={playing ? Pause : Play}
            alt={playing ? "pause" : "play"}
            style={{ width: 16, height: 16, paddingTop: 1 }}
          />
          <span style={{ position: "absolute", left: 40 }}>video</span>
        </div>
      </animated.div>
      <animated.div
        className="z-40 button muted-button flex flex-row items-center"
        style={buttonStyle}
        role="button"
        onClick={() => {
          setMuted((muted) => !muted);
        }}
      >
        {muted ? <Muted /> : <Unmuted />}
      </animated.div>
      <header className="absolute top-0 flex flex-row justify-between items-center w-full p-4 h-16 md:h-20">
        <img src={Logo} alt="logo" className="h-full" />
        <a
          className="flex items-center buy-button"
          href="https://www.mitsubishi-kyw.co.th/Product/For-Home/Fan.aspx"
          role="button"
        >
          รายละเอียดเพิ่มเติม
        </a>
      </header>
    </section>
  );
};

export default VideoSection;
